export enum LeadershipStatus {
    Yes = 'yes',
    No = 'no',
    Maybe = 'maybe',
}
